import { render, staticRenderFns } from "./yandex-recommendations.component.vue?vue&type=template&id=6c64f54d&"
import script from "./yandex-recommendations.component.vue?vue&type=script&lang=ts&"
export * from "./yandex-recommendations.component.vue?vue&type=script&lang=ts&"
import style0 from "./yandex-recommendations.component.vue?vue&type=style&index=0&id=6c64f54d&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports